module.exports = __webpack_public_path__ + "static/media/fcc-mobile.b54fb0f1.png";